import VueRouter from 'vue-router'
import Front from '@/components/front/index'
import PageNotFound from '@/components/front/404'
import Home from '@/components/front/home'
import Help from '@/components/front/help'
import Terms from '@/components/front/terms'
import Cookie from '@/components/front/cookie'
import Privacy from '@/components/front/privacy'
import Refund from '@/components/front/refund'
import News from '@/components/front/news/list'
import NewsItem from '@/components/front/news/item'
import Login from '@/components/login'
import Profile from '@/components/account/profile'
import Signup from '@/components/account/signup'
import Forgot from '@/components/account/forgot'
import Advertiser from '@/components/advertiser/index'
import Dashboard from '@/components/advertiser/dashboard'
import DomainLists from '@/components/advertiser/campaign/manager/domains'
import IpLists from '@/components/advertiser/campaign/manager/iplist'
import Report from '@/components/advertiser/report/index'

import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  if (localStorage.getItem('user-token')) {
    localStorage.setItem('return-login', this.$route.fullPath)
    next('login')
  }
  next('/signup')
}

export default new VueRouter({
  mode: 'history',
  routes: [
    { path: '/',
      component: Front,
      alias: ['/technology'],
      children: [
        { path: '/',
          alias: ['/technology'],
          component: Home,
          name: 'Home'
        }
      ]
    },
    { path: '/advertiser',
      component: Advertiser,
      beforeEnter: ifAuthenticated,
      children: [
        { path: '/',
          component: Dashboard,
          name: 'Dashboard'
        },
        { path: 'campaigns-manager/domains',
          component: DomainLists,
          name: 'Domain lists'
        },
        { path: 'campaigns-manager/iplist',
          component: IpLists,
          name: 'IP lists'
        },
        { path: 'reports/bydate',
          component: Report,
          beforeEnter: ifAuthenticated,
          name: 'Reports manager by date'
        }
      ]
    },
    { path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: ifAuthenticated
    },
    { path: '/login',
      component: Login,
      name: 'Login',
      beforeEnter: ifNotAuthenticated
    },
    { path: '/signup',
      name: 'Signup',
      component: Signup
    },
    { path: '/forgot',
      name: 'Forgot',
      component: Forgot,
      beforeEnter: ifNotAuthenticated
    },
    { path: '/news',
      component: Front,
      children: [
        {
          path: '/',
          component: News,
          name: 'News'
        },
        {
          path: ':slug',
          name: 'NewsItem',
          component: NewsItem
        }
      ]
    },
    { path: '/help',
      component: Front,
      children: [
        {
          path: '/',
          component: Help,
          name: 'Help'
        }
      ]
    },
    { path: '/terms_of_service',
      name: 'terms',
      component: Terms
    },
    { path: '/privacy_policy',
      name: 'Privacy',
      component: Privacy
    },
    { path: '/cookie_policy',
      name: 'Cookie',
      component: Cookie
    },
    { path: '/refund_policy',
      name: 'Refund',
      component: Refund
    },
    { path: '/404',
      component: Front,
      children: [
        {
          path: '/',
          component: PageNotFound,
          name: 'PageNotFound'
        }
      ]
    },
    { path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js